import { DateInputWUT } from '@wix/form-fields/viewer-wut';

export default DateInputWUT;
